export const URL_FROM_PARAMS = {
  'cache-manager': '/cache/cache-manager',
  'rendering-locations': '/settings/general',
  sitemaps: '/sitemaps',
  dashboard: '/',
  cdnAnalytics: '/cdn-analytics',
  domainManager: '/domain-manager',
  overview: '/billing/overview',
} as const;

export type URLFromParams = keyof typeof URL_FROM_PARAMS;
